import PropTypes from 'prop-types';
import React from 'react';
import translations from './translations.js';

const View = ({
  style,
  language = 'en_US',
  ...rest
}) => (
  <div
    {...rest}
    style={{
      fontSize: '16px',
      ...style
    }}
  >
    <p>{translations('mfaDescription', language)}</p>
  </div>
);

export default View;